import React from "react";
import ItemWork from "./item-work";

const CollectionWork = ({ data, handleUpdateOeuvre }) => {

    return (
        <div className="pr-4 md:pr-0">
            {Array.isArray(data) && data.map((item, index) => (
                <ItemWork
                    item={item}
                    key={index}
                    onClick={()=>handleUpdateOeuvre(item.id)} />
            ))}
        </div>
    )
}
export default CollectionWork;
